import(/* webpackMode: "eager" */ "/var/www/stms/FrontEnd/src/app/welcome/about/page.tsx");
